import { ExternalLinkIcon } from '@chakra-ui/icons'

export const LinkIcon = () => <ExternalLinkIcon style={{ margin: '2px', transform: 'translate(0, -2px)' }} />